import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApiService } from '../../../../core/services/api.service';
import { AsideComponent } from '../../../aside/aside.component';
import { DeliveryOperativeDetailDto } from '../../models/delivery-operative-detail';
import { Address } from '../../../../Models/address';
import { OneCoreMapHereComponent } from '../../../map/components/one-core-map-here/one-core-map-here.component';
import { OpenStreetMapService } from '../../../map/services/open-street-map.service';
import { DeliveryOperativeDocumentDto } from '../../models/delivery-operative-document';
import { ShipDetailEnum } from '../../../../enums/ship-detail-enum';
import { MessageService } from '../../../../core/services/message.service';
import { Ship } from '../../../../Models/ship';
import { ApiHereService } from '../../../map/services/api.here.service';
import { ShipStatusEnum } from '../../../../enums/ship-status-enum';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { DeliveryEvidenceDto } from '../../models/delivery-evidence-dto';
import { ShipHistory } from '../../models/ship-history';
import { DateUtcToLocalService } from '../../../../core/services/date-utc-to-local.service';
import { TranslateService } from '@ngx-translate/core';
import { ComboDto } from '../../../../dtos/combo-dto';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject, Subject } from 'rxjs';

@Component({
  selector: 'delivery-operative-detail',
  templateUrl: './delivery-operative-detail.component.html',
  styleUrls: ['./delivery-operative.component.scss']
})
export class DeliveryOperativeDetailComponent implements OnInit {
  @ViewChild("tableChild") tableChild: DataTableComponent<DeliveryEvidenceDto>;
  public filteredLoadCtrl: FormControl = new FormControl();
  public loadCtrl: FormControl = new FormControl();
  loadList: Array<ComboDto> = new Array<ComboDto>();
  public filteredLoad: ReplaySubject<ComboDto[]> = new ReplaySubject<ComboDto[]>(1);
  appointment: any = { newLoadId: 0, comment: '', newDate: new Date() };
  loadSelect: any = {};
  private _onDestroy = new Subject<void>();
  options = {
    columnTitles: ['#', 'DELIVERY_OPERATIVE.DETAIL.DOCUMENTATION.TABLE.DOCUMENT', 'DELIVERY_OPERATIVE.DETAIL.DOCUMENTATION.TABLE.TYPE', 
      'DELIVERY_OPERATIVE.DETAIL.DOCUMENTATION.TABLE.DATE', 'DELIVERY_OPERATIVE.DETAIL.DOCUMENTATION.TABLE.DOWNLOAD'],
    columnReferences: ['id', 'name', 'evidenceType_EvidenceTypeEnum', 'date', 'actions'],
    actionButtons: { detail: true }
  };
  pagePath: string = 'api/Delivery/getEvidenceShip';

  @ViewChild(AsideComponent) aside: AsideComponent;
  @ViewChild('map') map: OneCoreMapHereComponent;
  minDate = new Date();
  @Output() onCloseEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  detail: DeliveryOperativeDetailDto;
  data: DeliveryOperativeDocumentDto[];
  statusText: string;

  mark1: any;
  mark2: any;

  shipStatusEnum = ShipStatusEnum;
  shipId: number;

  fromHourFormControl: FormControl;
  toHourFormControl: FormControl;
  commentFormControl: FormControl;

  historyOptions = {
    columnTitles: ["DELIVERY_OPERATIVE.DETAIL.HISTORY.DATE", "DELIVERY_OPERATIVE.DETAIL.HISTORY.DESCRIPTION"],
    columnReferences: ["date", "shipStatus"]
  };

  // ----------------------------------------Prototipos------------------------------------------
  initDate = new Date();

  displayedColumns: string[] = ['position', 'name', 'actions'];
  dataSource = [
    {position: 'Factura1.pdf', name: '9.8 KB'},
    {position: 'Factura1.xml', name: '10 KB'},
  ];
  // ----------------------------------------Prototipos------------------------------------------

  constructor(private apiHereService: ApiHereService, private apiService: ApiService, 
      private openStreetMapService: OpenStreetMapService, private messageService: MessageService, 
      private translateService: TranslateService, private dateUtcToLocalService: DateUtcToLocalService) {
    this.fromHourFormControl = this.initControl();
    this.toHourFormControl = this.initControl();
    this.commentFormControl = this.initControl();
  }

  ngOnInit(): void {
    this.detail = new DeliveryOperativeDetailDto();
    this.filteredLoadCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterLoad();
      });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  private initControl() {
    return new FormControl('', [
      Validators.required
    ]);
  }

  open(idLoad: number, idShip: number, idItem: number, position: number, idVehicle: number): void {
    this.shipId = idShip;
    this.getAddress(idLoad, idItem, position, idVehicle, idShip);
    this.getDetail(idShip, idItem);
    this.loadDocument();
    this.aside.open();
    this.getLoads();
  }

  onCloseEvent(): void {
    this.onCloseEmitter.emit();
  }

  private getDetail(idShip: number, idItem: number): void {
    this.apiService.get<DeliveryOperativeDetailDto>('api/Delivery/getDeliveryOperativeDetail/' + idShip + '/' + idItem)
      .subscribe((response: DeliveryOperativeDetailDto) => {
        if (response) {
          this.detail = response;
          this.statusText = this.getEnumText(this.detail.status);
        }
      });
  }

  onClickSave(): void {
    this.updateDeliveryDate(this.shipId, this.detail.deliveryDate, this.detail.fromHour, this.detail.toHour, this.detail.comment);
  }

  private updateDeliveryDate(id: number, deliveryDate: Date, fromHour: string, toHour: string, comment: string) {
    this.apiService.put<boolean>('api/Delivery/updateDeliveryDate',
      { id: id, deliveryDate: deliveryDate, fromHour: fromHour, toHour: toHour, comment: comment })
      .subscribe((response: boolean) => {
        if (response) {
          this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
            {
              article: 'GENERAL.MESSAGE.THE_2',
              function: 'DELIVERY_OPERATIVE.DETAIL.MESSAGES.FUNCTION',
              action: 'DELIVERY_OPERATIVE.DETAIL.MESSAGES.ACTION'
            });
        }
      });
  }

  private getAddress(idLoad: number, idItem: number, position: number, idVehicle: number, idShip: number): void {
    this.apiService.get<Address>('api/Delivery/getDeliveryOperativeAddress/' + idLoad + '/' + position + '/' + idVehicle)
      .subscribe((end: Address) => {
        if (position > 1 && end) {
          this.apiService.get<Address>('api/Delivery/getDeliveryOperativeAddress/' + idLoad + '/' + (position - 1) + '/' + idVehicle)
            .subscribe((start: Address) => {
              if (start && start.latitude && start.longitude && end.latitude && end.longitude) {
                this.setAddressLatLong(start, end, idShip);
              } else if (start) {
                this.startRoute(start);
                this.endRoute(end);
              } else {
                // this.mark1 = this.initUndefinedMark();
                this.endRoute(end);
                // this.messageService.warning('DELIVERY_OPERATIVE.DETAIL.MESSAGES.TITLE_STREET', 'DELIVERY_OPERATIVE.DETAIL.MESSAGES.STREET_NOT_FOUND', { street: end.street, number: end.extNumber, zip: end.zipCode });
              }
            });
        } else if (position == 1 && end) {
          this.apiService.get<Address>('api/Delivery/getDeliveryOperativeAddress/' + idItem)
            .subscribe((start: Address) => {
              if (start && start.latitude && start.longitude && end.latitude && end.longitude) {
                this.setAddressLatLong(start, end, idShip);
              } else if (start) {
                this.startRoute(start);
              } else {
                this.messageService.warning('DELIVERY_OPERATIVE.DETAIL.MESSAGES.TITLE_STREET', 'DELIVERY_OPERATIVE.DETAIL.MESSAGES.WAREHOUSE_NOT_FOUND');
              }
              this.endRoute(end);
            })
        }
      });
  }

  private setAddressLatLong(start: Address, end: Address, idShip: number) {
    let ships: Ship[] = [];

    ships.push({
      id: idShip,
      destination: {
        latitude: start.latitude,
        longitude: start.longitude
      }
    },
      {
        id: idShip,
        destination: {
          latitude: end.latitude,
          longitude: end.longitude
        }
      });

    this.setRoute(ships);
  }

  private startRoute(address: Address): void {
    this.openStreetMapService.getCordenadasByAddress(address).subscribe((result) => {
      if (result && result[0]) {
        address.latitude = result[0].lat;
        address.longitude = result[0].lon;

        this.mark1 = {
          id: address.id,
          lat: result[0].lat,
          lng: result[0].lon,
          data: address
        }

        this.map.setStartMarks(this.mark1);
        this.map.setMapCenter(this.mark1);
      } else {
        // this.mark1 = this.initUndefinedMark();
        this.messageService.warning('DELIVERY_OPERATIVE.DETAIL.MESSAGES.TITLE_STREET', 'DELIVERY_OPERATIVE.DETAIL.MESSAGES.STREET_NOT_FOUND', { street: address.street, number: address.extNumber, zip: address.zipCode });
      }
    });
  }

  private endRoute(address: Address): void {
    this.openStreetMapService.getCordenadasByAddress(address).subscribe((result) => {
      if (result && result[0]) {
        address.latitude = result[0].lat;
        address.longitude = result[0].lon;

        this.mark2 = {
          id: address.id,
          lat: result[0].lat,
          lng: result[0].lon,
          data: address
        }
        
        this.map.setEndMarks(this.mark2);
        this.map.setMapCenter(this.mark2);

      } else {
        this.mark2 = this.initUndefinedMark();
        this.messageService.warning('DELIVERY_OPERATIVE.DETAIL.MESSAGES.TITLE_STREET', 'DELIVERY_OPERATIVE.DETAIL.MESSAGES.STREET_NOT_FOUND', { street: address.street, number: address.extNumber, zip: address.zipCode });
      }
    });
  }

  private setRoute(ships: Ship[]) {
    this.apiHereService.getMarksFromShips(ships).subscribe((marks) => {

      this.mark1 = marks[0];
      this.mark2 = marks[1];
      
      //this.map.createMarks(marks);
      this.map.setStartMarks(this.mark1);
      this.map.setEndMarks(this.mark2);
      this.map.setMapCenter(this.mark1);
      //this.map.paintRoute();
    });
  }

  private initUndefinedMark(): any {
    return { id: 0 };
  }

  private loadDocument(): void {
    this.tableChild.loadPage({id: this.shipId});
  }

  public onClickDetail(element: DeliveryEvidenceDto): void {
    if(!element.document) {
      this.apiService.get<DeliveryEvidenceDto>('api/Delivery/getEvidenceDocument/' + element.id)
        .subscribe((response: DeliveryEvidenceDto) => {
          if(response) {
            element.document = response.document;
            element.mymeType = response.mymeType;
            element.extension = response.extension;
            this.download(element.document, element.mymeType, element.name, element.extension);
          }
        });
    } else {
      this.download(element.document, element.mymeType, element.name, element.extension);
    }
  }

  public onDownloadPdf(): void {
    this.apiService.get<DeliveryEvidenceDto>('api/Delivery/getPdfEvidence/' + this.shipId + '/' + this.translateService.currentLang)
      .subscribe((response: DeliveryEvidenceDto) => {
        if (response) {
          this.download(response.document, response.mymeType, response.name, 'pdf');
        }
      });
  }

  private download(b64Data: string, contentType: string, name: string, extension: string) : void {
    
    if(b64Data.includes('base64,')) {
      b64Data = b64Data.substring(b64Data.lastIndexOf(',') + 1)
    }

    let blob = this.b64toBlob(b64Data, contentType, null);
    let blobUrl = URL.createObjectURL(blob);

   // window.open(blobUrl, '_blank');
      var a = document.createElement('a')
      if (typeof a.download === 'undefined') {
        window.location.assign(blobUrl);
      } else {
        a.href = blobUrl
        if (name) {
          a.download = name + '.' + extension;
        } else {
          a.download = 'evidence' + '.' + extension;
        }
        document.body.appendChild(a)
        a.click()
      }

    /*let link = window.document.createElement('a');
    link.target = '_blank';
    link.href = blobUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);*/
  }

  private b64toBlob(b64Data: string, contentType: string, sliceSize: number) : Blob {
    contentType = contentType || 'application/octet-stream';
    sliceSize = sliceSize || 512;
  
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
  
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      let byteArray = new Uint8Array(byteNumbers);
  
      byteArrays.push(byteArray);
    }
  
    let blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  public getEnumText(e: any): string {

    if (e == 0) {
      return 'Cargado';
    } else if (e == 1) {
      return 'En tránsito';
    } else if (e == 2) {
      return 'Llego a destino';
    } else if (e == 3) {
      return 'Cliente ausente';
    } else if (e == 4) {
      return 'Entregado';
    } else if (e == 5) {
      return 'Recolectado';
    } else if (e == 6) {
      return 'Llegó al destino';
    } else if (e == 7) {
      return 'Pendiente';
    } else if (e == 8) {
      return 'Iniciar recorrido';
    } else if (e == 9) {
      return 'Notificado al cliente';
    }

    return '';
  }

  getStartMark() {
    return this.mark1;
  }
  getEndMark() {
    return this.mark2;
  }

  getLoads(): any {
    this.apiService.get<ComboDto[]>('api/load/getLoadCombo').subscribe((response: ComboDto[]) => {
      if (response) {
        this.loadList = this.loadList.concat(response);
        this.filteredLoad.next(this.loadList.slice());
        this.filteredLoad
          .pipe(take(1), takeUntil(this._onDestroy))
          .subscribe(() => {
            this.loadSelect.compareWith = (a: ComboDto, b: ComboDto) => a.value === b.value;
          });
      }
    });
  }

  private filterLoad() {
    if (!this.loadList) {
      return;
    }
    let search = this.filteredLoadCtrl.value;
    if (!search) {
      this.filteredLoad.next(this.loadList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredLoad.next(
      this.loadList.filter(v => v.text.toLowerCase().indexOf(search) > -1)
    );
  }
  saveAppointment(){
    this.apiService.put('api/load/reappointment/' + this.shipId, this.appointment).subscribe(() => {
      
    });
  }
}
